import React, { useEffect } from 'react'; 
import AllelicCurationBrowser from '../components/allelic-curation-browser';
import {
    useSearchParams,
} from "react-router-dom"; 

import Container from '@mui/material/Container';


export default function AllelicCuration() {
    let [searchParams, setSearchParams] = useSearchParams();
    const [curationData, setCurationData] = React.useState<any>(null);


    useEffect(() => {
        let _refId = searchParams.get("refId");
        let _altId = searchParams.get("altId");
        let _refExp:any = searchParams.get("refExp");
        let _altExp:any = searchParams.get("altExp");

        if(_refId)
        {
            setCurationData({"refId":_refId, "altId": _altId, "refExp":_refExp, "altExp":_altExp}); 
        }  
        console.log("curationData:",curationData);
    }, []);


    return (
        <Container maxWidth="lg">
            { curationData && 
                <AllelicCurationBrowser data={curationData}></AllelicCurationBrowser>
            }
        </Container>
    );
}